export default function ForbiddenIcon(props) {
  const { size = "24" } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7.5 12.78V5a1 1 0 0 1 1-1h7a.9.9 0 0 1 .33.06a.58.58 0 0 0 .39 0a1.4 1.4 0 0 0 .26-.18l1.3-1.3a.26.26 0 0 0 0-.35A2.52 2.52 0 0 0 16 1.5H8A2.5 2.5 0 0 0 5.5 4v10.28a.25.25 0 0 0 .43.17L7.43 13a.26.26 0 0 0 .07-.22M23.71.29a1 1 0 0 0-1.42 0l-22 22a1 1 0 0 0-.18 1.16a.9.9 0 0 0 .18.26a1 1 0 0 0 1.42 0l3.92-3.92A2.51 2.51 0 0 0 8 21.5h8a2.5 2.5 0 0 0 2.5-2.5V6.91l5.21-5.2a1 1 0 0 0 .18-1.16a.9.9 0 0 0-.18-.26M15.5 17H9l-.18-.43l7.23-7.23a.25.25 0 0 1 .43.18V16a1 1 0 0 1-.98 1"
      />
    </svg>
  );
}
